<template>
  <div>

    <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('qvct_survey.categories.list') }}</h3>
          </div>
          <div class="card-toolbar" >
            <Button btn-class="btn-sm" type="new" btn-text="setting.new_qvct_categorie" @click="openCreateModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_qvct_categories" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th> {{$t("qvct_survey.categories.name")}}</th>
              <th> {{$t("qvct_survey.categories.parent")}}</th>
              <th> {{$t("qvct_survey.categories.type")}}</th>
              <th>{{$t("actions")}}</th>
            </tr>
            </thead>
          </table>
        </div>

      </div>

    </div>

    <CreateQvctCategories
        id="create_qvct_categorie"
        @reloadDatatable="reloadDatatable"
    />

    <UpdateQvctCategories
        id="update_qvct_categorie"
        :editForm = editForm
        @reloadDatatable="reloadDatatable"
    />

  </div>
</template>

<script setup>
import {BASE_URL} from "@/services/api";
import { useRouter } from "vue-router"
import Ls from "@/services/ls";
import { useI18n } from 'vue-i18n'
import {useStore} from "vuex";
import {nextTick, onMounted, ref, watch} from "vue"
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from '@/composables/locales';
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import abilities from "@/composables/abilities";
import {Theme} from "@/composables/theming";
import CreateQvctCategories from "@/Modules/Qvct/components/CreateQvctCategories.vue";
import UpdateQvctCategories from "@/Modules/Qvct/components/UpdateQvctCategories.vue";


const {showSwal} = useSwal()
const { t } = useI18n({ useScope: 'global' })
const { can } = useHasAbility()


const table = ref(null)

const {locale, datatableLocaleUrl} = useLocales()

const editForm = ref({})

const router = useRouter()

const store = useStore()

onMounted(() => {
  qvctCategorie('kt_datatable_qvct_categories')
})

watch(() => locale.value, () => {
  nextTick(() =>  qvctCategorie('kt_datatable_qvct_categories') )
})

function openCreateModal(){
  $('#kt_modal_create_qvct_categorie').modal('toggle')
}

$(document).on("click", "#kt_datatable_qvct_categories .delete_btn", (e) => {
  deletePost(e.target.getAttribute('data-id'))
});

function qvctCategorie(tableId){
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')
  table.value = $("#" + tableId).DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + "/get/qvct/survey/categories/dataTable",
      type: "GET",
      beforeSend: function (request, options) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [{ data: "name" }, { data: "parent_name" }, { data: "parent_type" }, { data: "Actions", responsivePriority: -1 }],
    columnDefs: [

      {
        targets: -4,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        targets: -3,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        targets: -2,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t[locale.value] + "</span>";
        },
      },
      {
        width: "15%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render=""


            render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-parent_id="'+ e.parent_id +'" " data-parent_type="'+ e.parent_type.value +'"  class="btn btn-sm btn-clean btn-icon edit_btn" ><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" " data-parent_id="'+ e.parent_id +'" " data-parent_type="'+ e.parent_type.value +'" class="fas fa-edit fs-2" data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.edit')+'" style="color: '+Theme.gray +'"></i></a>'



            render += '<a href="javascript:;"  data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn"><i  data-id="'+ e.id +'" class="fas fa-trash fs-2"  data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.delete')+'" style="color: '+Theme.gray +'"></i></a>'


          return render
        },
      },
    ],
    language: {
      url:  datatableLocaleUrl.value
    }
  });

}

$(document).on("click", "#kt_datatable_qvct_categories .edit_btn", (e) => {
  editForm.value.id = e.target.getAttribute('data-id')
  editForm.value.name = e.target.getAttribute('data-name')
  editForm.value.parent_id = e.target.getAttribute('data-parent_id')
  editForm.value.parent_type = e.target.getAttribute('data-parent_type')

  $('#kt_modal_update_qvct_categorie').modal('toggle')
});


$(document).on("click", "#kt_datatable_qvct_categories .delete_btn", (e) => {
  editForm.value.id = e.target.getAttribute('data-id')

});


function reloadDatatable() {
  qvctCategorie('kt_datatable_qvct_categories')
}

async function deletePost(id){
  showSwal(
      '',
      i18n.global.t('swal.category_deleting')
  ).then( async (result) => {
    if (result.value) {
      try {
        console.log(id)
        await store.dispatch('qvctCategories/deleteQvctCategorie', { id })
        reloadDatatable()
        window.toastr.success(t('notification.category_deleted'))
      }catch (e) {
      }
    }
  })
}

</script>
